// extracted by mini-css-extract-plugin
export default {"collapseHeader":"IECollapseHeader_collapseHeader__73z4Z","ieLibraryLink":"IECollapseHeader_ieLibraryLink__Dl5KC"};